import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import arrowLeft from './images/arrow-left-terms.svg'

const InternetPackageCard = (props) => {
    return (
        <div className="internet-package-card-wrapper">
            <div className="internet-package-card">
                <div className="title"> <h3>{props.package.name}</h3> </div>                    
                <div className="speed-wrapper">
                    <div className="speed">הורדה עד<br />
                        <span>{props.package.downloadSpeed} Mbps</span>
                    </div>
                    <div className="speed">מהירות העלאה<br />
                        <span>{props.package.uploadSpeed} Mbps</span>
                    </div>
                </div>
                <div className="price-row">
                    <div className="price-wrapper"><span className="nis">₪</span><span className="price">{props.package.additionalPrice}<br /><span className="period">לחודש</span></span></div>
                    <BtnSubmit formid="internet-package-card" onclick={() => props.onSelected(props.package)} text="מתאים לי" ></BtnSubmit>
                </div>
            </div>
            <div className="terms">
                <a href={props.package.productTermsLink} target="_blank">תנאי החבילה<Image src={arrowLeft} /></a>
            </div>           
        </div>
    )
}

export default InternetPackageCard;